



























































































































































import RouteTab from '@/components/RouteTab.vue';
import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { BvTableFieldArray } from 'bootstrap-vue';

import { FeedTank, FeedTankLegShapes, Sensor, Transceiver } from '@/api';
import { FeedProduct, feedTankAuditFields, FeedType } from '../../../models';
import { FeedProductService } from '../../../services';

import InformationRow from '@/components/display/information-row.vue';
import FeedTankVolumeDisplay from './components/FeedTankVolumeDisplay.vue';
import LocationRow from '@/components/display/information-rows/location-row.vue';
import LastCheckInTag from '@/components/display/information-rows/last-check-in-tag.vue';
import LiveAtRow from '@/components/display/information-rows/live-at-row.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import { formattedStatus } from '@/common/StatusUtil';

/** Sensor type value for strain-gauge sensors (affects capacity and config visibility). */
const SENSOR_TYPE_STRAIN = 'strain';

@Component({
	components: {
		RouteTab,
		ChangelogLink,
		LastCheckInTag,
		LiveAtRow,
		LocationRow,
		InformationRow,
		FeedTankVolumeDisplay,
	},
	methods: {
		formattedStatus,
	},
})
export default class FeedTankGeneralSection extends Vue {
	private legShapes: FeedTankLegShapes[] = [];
	private readonly service = new FeedProductService();

	public async created(): Promise<void> {
		const response = await this.service.getFeedTankLegShapes();
		this.legShapes = response.legShapes ?? [];
	}

	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank & {
		transceiver: Transceiver | null;
		sensor: Sensor | null;
		sensors?: Sensor[] | null;
		sensorType?: string | null;
		feedtype: FeedType | null;
	};

	@InjectReactive('siteTransceivers')
	public siteTransceivers!: Transceiver[];

	/** Whether the site has a LoRaWAN gateway available, for strain tanks with no transceiver of their own. */
	public get siteHasGateway(): boolean {
		return (this.siteTransceivers ?? []).some(
			transceiver => transceiver.type === 'lorawan_gateway',
		);
	}

	/** Normalized array of sensors (from feedTank.sensors or single feedTank.sensor). */
	public get feedTankSensors(): Sensor[] {
		const s = this.feedTank?.sensors ?? this.feedTank?.sensor;
		if (Array.isArray(s)) return s.filter(Boolean);
		return s ? [s] : [];
	}

	/** Expose SENSOR_TYPE_STRAIN for template (strain-gauge sensor type). */
	public get sensorTypeStrain(): string {
		return SENSOR_TYPE_STRAIN;
	}

	public get feedTypeName(): string {
		return this.feedTank.feedtype?.name ?? 'No feed type';
	}

	public get legShapeLabel(): string {
		if (!this.feedTank.legShape) return '—';
		return (
			this.legShapes.find(s => s.value === this.feedTank.legShape)?.label ?? this.feedTank.legShape
		);
	}

	public get capacityValue(): string {
		const tonnes = (this.$options.filters as any)?.tonnes(this.feedTank.nominalWeight);
		if (this.feedTank.sensorType === SENSOR_TYPE_STRAIN) {
			return tonnes ?? '';
		}
		return `${this.feedTank.nominalVolume} L | ${tonnes}`;
	}

	public get auditFields(): BvTableFieldArray {
		return feedTankAuditFields;
	}

	private sortedParameters(obj: any, parameters: string) {
		const split = parameters
			?.replace(/(\n|\r\n|\r)/g, '\n')
			.split('\n')
			.map(x => x.split('|')[1]);
		return split ?? Object.keys(obj ?? {}) ?? [];
	}
}
